import { useQuery, keepPreviousData } from '@tanstack/react-query';
import type { ApropriacaoEntrada, ApropriacaoPreviaResponse } from '@triade/contracts';
import { ApiError, requisitar } from '@/lib/api';
import { useSessao } from '@/lib/session';

export type ReferTo = 'PESSOA' | 'IMOBILIZADO' | 'CIF' | 'CENTRO_CUSTO';

/**
 * Previa da apropriacao (POST /apropriacoes/previa): nada e gravado. A API calcula os percentuais de IGUAL e CRITERIO;
 * o front so mostra. MANUAL nao chama a previa (os percentuais sao digitados). `entrada` null = nao consulta.
 */
export function usePreviaApropriacao(referTo: ReferTo, entrada: ApropriacaoEntrada | null) {
  const { empresaId } = useSessao();
  const consultar = entrada !== null && entrada.tipo !== 'MANUAL' && empresaId !== null;
  return useQuery<ApropriacaoPreviaResponse, ApiError>({
    queryKey: ['apropriacoes', 'previa', empresaId, referTo, entrada],
    queryFn: () => requisitar<ApropriacaoPreviaResponse>('/apropriacoes/previa', { method: 'POST', body: { referTo, entrada } }),
    enabled: consultar,
    placeholderData: keepPreviousData,
  });
}
